import './scss/datetimefieldeditor.scss'
import {DatetimeFieldEditorComponent} from './DatetimeFieldEditorComponent'

const DatetimeFieldEditorPackage = {
    name: 'UIDatetimeFieldEditor',
    configure: function(config) {

        config.addComponent('UIDatetimeFieldEditor', DatetimeFieldEditorComponent, false, 'datetime-field-editor')
    }
}

export {DatetimeFieldEditorPackage}
